import * as React from 'react';
export const CASvg = React.forwardRef(function CASvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M5 2h6v12H5z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M5 14v-1h6v1H5ZM5 2h6v1H5V2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'M5 14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3v12Zm9 0h-3V2h3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'm7.673 9.283-.999-.006.126-.585-1.3-.198.462-.855-.414-1.132 1.138.453.336-1.299.499.254.477-.916.543.903.443-.204.214 1.255 1.266-.398-.389 1.05.425.882-1.257.205.115.579-1.03-.01.006 1.418-.659.014z',
      }),
    ),
  );
});
CASvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var CA = {
  category: 'flag',
  colorable: false,
  name: 'CA',
  svg: CASvg,
};
